import * as React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_LANGUAGE, LOCAL_STORAGE } from '@constants';
import { Lock } from '@airtm/airtm-ui';
import MfaForm from '../MfaForm/MfaForm';

function helpLink() {
  const lang = localStorage.getItem(LOCAL_STORAGE.LANGUAGE) || DEFAULT_LANGUAGE;
  let link = null;
  switch (lang) {
    case 'en':
      link =
        'https://help.airtm.com/en/support/solutions/articles/47001116947-i-m-having-problems-with-the-2fa-code';
      break;
    case 'es':
      link =
        'https://help.airtm.com/es/support/solutions/articles/47001116947-tengo-problemas-con-el-c%C3%B3digo-2fa';
      break;
    case 'pt':
      link =
        'https://help.airtm.com/es/support/solutions/articles/47001116947-tengo-problemas-con-el-c%C3%B3digo-2fa';
      break;
    default:
      break;
  }
  return link;
}

const MfaFormContainer = function (props) {
  const { t } = props;
  return (
    <section className="section my-8 mt-sm-6 mt-md-5">
      <Lock className="text--black mb-4" size={32} />

      <h1>
        <span>{t('LOGIN:MFA_HEADER')}</span>
      </h1>

      <div className="section__content">
        <MfaForm {...props} />

        <p className="font-weight--bold font--sm text--left">
          <a rel="noopener noreferrer" href={helpLink()} target="_blank">
            {t('LOGIN:LINK_PROBLEMS_WITH_MFA')}
          </a>
        </p>
      </div>
    </section>
  );
};

MfaFormContainer.propTypes = {
  t: PropTypes.func.isRequired,
};

export default MfaFormContainer;
